export default __webpack_public_path__ + "static/media/MusicH1.109222a8.png";